/* eslint-disable @typescript-eslint/no-explicit-any */
const REG_HTTP = /^https?:/i;

let LinkClickHelpers = {
  // make sure all links open in a new tab/window
  enforceNewDocument(event: Event) {
    let el: Element = event.target as any;
    while (el && el.nodeName.toLowerCase() !== 'a') {
      el = el.parentElement as Element;
    }
    if (el == null) {
      return;
    }
    let a: HTMLAnchorElement = el as any;
    if (REG_HTTP.test(a.href)) {
      a.target = '_blank';
    }
  },

  // prevent navigation for href="#"
  enforceEmptyFragment(event: Event) {
    let el: Element = event.target as any;
    while (el && el.nodeName.toLowerCase() !== 'a') {
      el = el.parentElement as Element;
    }
    if (el == null) {
      return;
    }
    let a: HTMLAnchorElement = el as any;
    if (a.getAttribute('href') === '#') {
      event.preventDefault();
    }
  },
};

export default LinkClickHelpers;
